// extracted by mini-css-extract-plugin
export default {"settings":"wNGXNyY0HN7y2hW2Lhtl","input":"YfkWkpX1rGcLuMBraUmC"};